/**
 * Regras de seleção de categoria/sub categoria da tela de Categorias.
 *
 * A lista de sub categorias é SEMPRE derivada da lista de categorias vinda da
 * API (`/products/categories`), nunca de um snapshot em estado: o snapshot
 * ficava vazio a cada refresh (`getCategories`) e a cada clique numa linha de
 * sub categoria, impedindo a edição.
 */

export function selectSubCategories(categories, parentId) {
  if (!parentId || !Array.isArray(categories)) {
    return [];
  }

  const parent = categories.find((item) => item.id === parentId);

  return parent && Array.isArray(parent.subCategories)
    ? parent.subCategories
    : [];
}

/**
 * A sub categoria só pode ser criada com uma categoria pai selecionada; sem
 * isso o POST ia com `parentCategoryId` vazio e criava uma categoria raiz.
 */
export function validateNewSubCategory(parentId, label, subCategories = []) {
  if (!parentId) {
    return {
      ok: false,
      msg: "Selecione a categoria antes de adicionar a sub categoria.",
    };
  }

  if (label === "" || label === undefined || label === null) {
    return { ok: false, msg: "O campo Sub Categoria deve ser preenchido." };
  }

  const existe = subCategories.find(
    (item) => item.ref === label.toString().toUpperCase(),
  );

  if (existe) {
    return { ok: false, msg: "Sub Categoria existente!" };
  }

  return { ok: true, msg: "" };
}
